import { useState } from "react";
import { Col, Container, Navbar, Row } from "react-bootstrap";
import logo from "../../assets/img/logo.png";
import face from "../../assets/img/face.png";
import insta from "../../assets/img/insta.png";

import ModalContacto from "../ModalContacto/ModalContacto";

const Header = () => {
  const [modalShow, setModalShow] = useState(false);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <>
      {
        //HEADER DESKTOP
      }
      <Container fluid className="d-md-block d-none">
        <Row>
          <Container fluid className="header">
            <Container>
              <Row>
                <Col md={10} xs={12} className="mx-auto p-0 m-0">
                  <Row>
                    <Col md={10} xs={12} className="">
                      <img src={logo} alt="Montironi" />
                    </Col>
                    <Col md={2} xs={12} className="d-md-flex d-none justify-content-end">
                      <div>
                        <ul className="list-unstyled pt-1">
                          <li className="list-inline-item">
                            <div>
                              <a href="https://www.facebook.com/montironiok " target="_blank" rel="noreferrer">
                                <img src={face} alt="Montironi" />
                              </a>
                            </div>
                          </li>
                          <li className="list-inline-item">
                            <div>
                              <a href="https://www.instagram.com/montironiok/" target="_blank" rel="noreferrer">
                                <img src={insta} alt="Montironi" />
                              </a>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Container>
          </Container>
        </Row>
      </Container>
      {
        //HEADER MOBILE
      }
      <Container fluid className="header d-block d-md-none">
        <Container>
          <Row>
            <Col md={12} className="d-flex justify-content-md-between justify-content-center flex-md-row flex-column">
              <Container>
                <div onClick={() => scrollToTop()} style={{ cursor: "pointer" }} className="text-center">
                  <img src={logo} alt="Montironi" />
                </div>
              </Container>
            </Col>
          </Row>
        </Container>
      </Container>
      {
        //MODAL CONTACTO
      }
      <ModalContacto show={modalShow} onHide={() => setModalShow(false)} />
      <div name="marcas"></div>
    </>
  );
};

export default Header;
